import { useEffect, useState } from "react";
import { parsePrice } from "./price.utils";

const pricePattern = /^\d+,\d{2}$/;

const priceStringToNumber = (price) => {
  return Number(price.replace(",", "."));
};

const isAtacadoMoreExpensive = (varejoPrice, atacadoPrice) => {
  if (!pricePattern.test(varejoPrice) || !pricePattern.test(atacadoPrice)) {
    return false;
  }

  return priceStringToNumber(atacadoPrice) > priceStringToNumber(varejoPrice);
};

export const useVarejoAtacadoModal = ({
  products,
  currentProductId,
  isOpen,
  onSave,
}) => {
  const [form, setForm] = useState({
    varejoPrice: "",
    atacadoPrice: "",
  });

  useEffect(() => {
    if (!isOpen || !products?.length) return;

    const currentProduct = products[currentProductId];
    if (!currentProduct) return;

    setForm({
      varejoPrice: currentProduct.varejoPrice || "",
      atacadoPrice: currentProduct.atacadoPrice || "",
    });
  }, [isOpen, products, currentProductId]);

  const updateField = (field, rawValue) => {
    const parsed = parsePrice(rawValue);
    if (!parsed) return;

    setForm((prev) => ({
      ...prev,
      [field]: parsed,
    }));
  };

  const isVarejoValid = pricePattern.test(form.varejoPrice);
  const isAtacadoValid = pricePattern.test(form.atacadoPrice);
  const atacadoMoreExpensive = isAtacadoMoreExpensive(
    form.varejoPrice,
    form.atacadoPrice,
  );
  const canSave = isVarejoValid && isAtacadoValid && !atacadoMoreExpensive;

  const save = () => {
    if (!canSave) return;

    onSave({
      varejoPrice: form.varejoPrice,
      atacadoPrice: form.atacadoPrice,
      promotionType: "VAREJO_ATACADO",
    });
  };

  return {
    form,
    updateField,
    save,
    canSave,
    isVarejoValid,
    isAtacadoValid,
    atacadoMoreExpensive,
  };
};
